module.exports = __webpack_public_path__ + "assets/img/b1c5-vg.svg";